import React, {Component} from "react";
import {Grid, Card, Typography, Button, IconButton, 
    Tooltip, Chip, TextField,CircularProgress,
    Dialog,DialogActions,DialogContent,DialogContentText,
    DialogTitle,withMobileDialog
} from "@material-ui/core";
import {withStyles} from "@material-ui/core/styles";
import {FileCopyTwoTone,AutorenewTwoTone,Edit,CloudDownload} from "@material-ui/icons";
import {CopyToClipboard} from "react-copy-to-clipboard";
import classNames from "classnames";
import {message} from "antd";
import PropTypes from "prop-types";
let fileDownload = require("js-file-download");


const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
    mainGrid: {
        marginTop: theme.spacing.unit * 3,
    },
    Paper: {
        padding: theme.spacing.unit * 3,
        margin: theme.spacing.unit * 3
    },
    chip: {},
    button: {},
    leftIcon: {
        //marginRight: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 20,
    },
    progress: {
        margin: theme.spacing.unit * 2,
    },
    textField: {
        marginTop: 3,
    },
});

class Intigrate extends Component {

    constructor(props) {
        super(props);
        this._success = this._success.bind(this);
        this._gerateApitKey = this._gerateApitKey.bind(this);
        this._downloadPrivateKey = this._downloadPrivateKey.bind(this);
        this._downloadPublicKey = this._downloadPublicKey.bind(this);
        this._generatePrivateKey = this._generatePrivateKey.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this._setEndPoint = this._setEndPoint.bind(this);
    }

    componentWillMount() {
        if (!this.props.Merchant.id && !this.props.Merchant.apiKey) {
            this.props.allProps.getMerchantDetail();
        }
    }

    componentDidMount(){
        // if (!this.props.Merchant.privateKey && !this.props.Merchant.publicKey) {
        //     this.props.allProps.merchantKey(this.props.allProps.User, 'public_key');
        //     this.props.allProps.merchantKey(this.props.allProps.User, 'private_key');
        // }
    }

    state = {
        copied: false,
        mEndpoint : "",
        open: false,
    };

    _success() {
        message.success("Copy Success.");
    }

    _gerateApitKey() {
        this.props.allProps.generateApiKey();
    }

    _downloadPublicKey(){
        fileDownload(this.props.Merchant.publicKey, "directpay_publicKey.pem");
    }

    _downloadPrivateKey(){
        fileDownload(this.props.Merchant.privateKey, "directpay_privateKey.pem");
    }

    _generatePrivateKey(){
        this.props.allProps.generateMerchantKey(this.props.allProps.User);
    }

    handleChange = (e) => {
        this.setState({mEndpoint: e.target.value});
    }

    handleClickOpen = () => {
        this.setState({ open: true, mEndpoint: this.props.Merchant.endPoint });
    };
    
    handleClose = () => {
        this.setState({ open: false });
    };

    _setEndPoint(){
        this.props.allProps.setEndpoint(this.state.mEndpoint);
        this.setState({ open: false, mEndpoint: "" });
    }

    mouseLeave = () => {
        this.setState({ copied: false });
    }

    render() {
        const {classes, fullScreen} = this.props;
        const {
            id, apiKey, loading, isLoading, privateKey, isKeyGenerate,
            isDownloadPublic, isDownloadPrivate, endPoint, isUpdateEndpoint
        } = this.props.Merchant;
        return (

            <Grid item md={10} xl={10}>
                <Card className={classes.root}>
                    <Grid container spacing={8}>
                        <Grid item sm>
                            <Typography variant="overline" gutterBottom>Merchant ID: </Typography>
                            {loading ?
                                <CircularProgress className={classes.progress} size={20}/>
                                :
                                <div>
                                    {id ?
                                        <div>
                                            <Chip label={id} className={classes.chip} clickable color="primary"
                                                variant="outlined"/>
                                            <CopyToClipboard text={id} onCopy={() => this.setState({copied: true})}
                                                onClick={this._success}>
                                                <Tooltip title={this.state.copied ? "Copied" : "Copy"} placement="top">
                                                    <IconButton variant="fab" mini="true" aria-label="Copy"
                                                        className={classes.button}
                                                        onMouseLeave={this.mouseLeave}
                                                    >
                                                        <FileCopyTwoTone/>
                                                    </IconButton>
                                                </Tooltip>
                                            </CopyToClipboard>
                                        </div>
                                        :
                                        <Chip label='-' className={classes.chip} clickable color="primary"
                                            variant="outlined"/>
                                    }
                                </div>
                            }
                        </Grid>
                        <Grid item sm>
                            <Typography variant="overline" gutterBottom>API Key: </Typography>

                            {loading ?
                                <CircularProgress className={classes.progress} size={20}/>
                                :
                                <div>
                                    {apiKey ?
                                        <div>
                                            <Chip label={apiKey} className={classes.chip} clickable color="primary"
                                                variant="outlined"/>
                                            <CopyToClipboard text={apiKey}
                                                onCopy={() => this.setState({copied: true})}
                                                onClick={this._success}>
                                                <Tooltip title={this.state.copied ? "Copied" : "Copy"} placement="top">
                                                    <IconButton variant="fab" mini="true" aria-label="Copy"
                                                        className={classes.button}
                                                        onMouseLeave={this.mouseLeave}
                                                    >
                                                        <FileCopyTwoTone/>
                                                    </IconButton>
                                                </Tooltip>
                                            </CopyToClipboard>
                                        </div>
                                        :
                                        <div>
                                            {isLoading ?
                                                <CircularProgress className={classes.progress} size={20}/>
                                                :
                                                <Tooltip title="Generate API key" placement="top">
                                                    <IconButton variant="contained" color="primary" size="small"
                                                        className={classes.button}
                                                        onClick={this._gerateApitKey}>
                                                        <AutorenewTwoTone
                                                            className={classNames(classes.leftIcon, classes.iconSmall)}/>
                                                    </IconButton>
                                                </Tooltip>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </Grid>
                        <Grid container spacing={8}>
                            <Grid item sm>
                                <Typography variant="overline" gutterBottom>Public Key: </Typography>
                                {loading ?
                                    <CircularProgress className={classes.progress} size={20}/>
                                    :
                                    <div>
                                        {isDownloadPublic ?
                                            <CircularProgress className={classes.progress} size={20}/>
                                            :
                                            <Button size="small" variant="outlined" color="primary" onClick={this._downloadPublicKey}
                                                className={classes.button}>
                                                    Download
                                                <CloudDownload className={classes.rightIcon}/>
                                            </Button>
                                        }
                                    </div>
                                }
                            </Grid>
                            <Grid item sm>
                                <Typography variant="overline" gutterBottom>Private Key: </Typography>
                                {loading ?
                                    <CircularProgress className={classes.progress} size={20}/>
                                    :
                                    <div>
                                        {isDownloadPrivate ?
                                            <CircularProgress className={classes.progress} size={20}/>
                                            :
                                            <div>
                                                {privateKey ?
                                                    <Button size="small" variant="outlined" color="primary" onClick={this._downloadPrivateKey}
                                                        className={classes.button}>
                                                        Download
                                                        <CloudDownload className={classes.rightIcon}/>
                                                    </Button>
                                                    :
                                                    <div>
                                                        {isKeyGenerate ?
                                                            <CircularProgress className={classes.progress} size={20}/>
                                                            :
                                                            <Tooltip title="Generate Private key" placement="top">
                                                                <IconButton variant="contained" color="primary" size="small" onClick={this._generatePrivateKey}
                                                                    className={classes.button}>
                                                                    <AutorenewTwoTone
                                                                        className={classNames(classes.leftIcon, classes.iconSmall)}/>
                                                                </IconButton>
                                                            </Tooltip>
                                                        }
                                                    </div>
                                                }
                                            </div>                                       
                                        }                                     
                                    </div>
                                }
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item sm style={{paddingTop:15}}>
                                <Typography variant="overline" gutterBottom>Confirmation Endpoint: </Typography>
                                <Grid container spacing={8}>
                                    <Grid item sm>
                                        {loading ?
                                            <CircularProgress className={classes.progress} size={20}/>
                                            :
                                            <div> 
                                                {isUpdateEndpoint ?
                                                    <CircularProgress className={classes.progress} size={20}/>
                                                    :
                                                    <div>
                                                        {endPoint ?
                                                            <div>
                                                                <Chip label={endPoint} className={classes.chip} clickable color="primary"
                                                                    variant="outlined"/> 
                                                                <CopyToClipboard text={endPoint}
                                                                    onCopy={() => this.setState({copied: true, mEndpoint : endPoint})}
                                                                    onClick={this._success}>
                                                                    <Tooltip title={this.state.copied ? "Copied" : "Copy"} placement="top">
                                                                        <IconButton variant="fab" mini="true"
                                                                            aria-label="Copy"
                                                                            className={classes.button}
                                                                            onMouseLeave={this.mouseLeave}
                                                                        >
                                                                            <FileCopyTwoTone/>
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </CopyToClipboard>
                                                                <Tooltip title="Set Confirmation Endpoint"
                                                                    placement="top">
                                                                    <IconButton variant="outlined" color="secondary" onClick={this.handleClickOpen}
                                                                        size="small" className={classes.button}>
                                                                        <Edit
                                                                            className={classNames(classes.leftIcon, classes.iconSmall)}/>
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </div> 
                                                            :
                                                            <Tooltip title="Set Confirmation Endpoint"
                                                                placement="top">
                                                                <IconButton variant="outlined" color="secondary" onClick={this.handleClickOpen}
                                                                    size="small" className={classes.button}>
                                                                    <Edit
                                                                        className={classNames(classes.leftIcon, classes.iconSmall)}/>
                                                                </IconButton>
                                                            </Tooltip>
                                                        }                                                 
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Card>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="responsive-dialog-title"
                    fullScreen={fullScreen}
                >
                    <DialogTitle id="form-dialog-title">Set Endpoint</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            please enter your Confirmation Endpoint here.
                        </DialogContentText>
                        <TextField
                            autoFocus
                            margin="dense"
                            value={this.state.mEndpoint ? this.state.mEndpoint : "" }
                            onChange={this.handleChange}
                            id="ednpoint"
                            label="ENDPOINT"
                            type="text"
                            fullWidth
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this._setEndPoint} color="primary">
                            Set
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid>

        );
    }
}

Intigrate.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(withStyles(styles)(Intigrate));